
export const print = (string: string) => {
    console.log(`print: ${string}`)
}